import { render, staticRenderFns } from "./WastePage.vue?vue&type=template&id=9853cc92&scoped=true&"
import script from "./WastePage.vue?vue&type=script&lang=js&"
export * from "./WastePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9853cc92",
  null
  
)

export default component.exports